import type { Route } from 'next';
import type { ReactNode } from 'react';

import { Link } from '#components/Link/Link';

import styles from './ArticleItemImage.module.scss';

type Props = {
	image: ReactNode;
	path: Route;
	title: string;
};

export function ArticleItemImage({ image, path, title }: Props) {
	return (
		<Link className={styles.imageLink} title={title} href={path} tabIndex={-1}>
			{image}
		</Link>
	);
}
